import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import { CUDGroupResponse } from "./interfaces/userInterface.interface";
import qs from "qs";
import {
  CreateGroupRequest,
  GetGroupListResposne,
  GetGroupRequest,
} from "api/interfaces/userInterface.interface";
import { CustomError } from "./interfaces/commonInterface.interface";
const USER_GROUP_PATH = "/ugroup";

export const getGroupList = async ({
  payload,
  accountId,
}: {
  payload: GetGroupRequest;
  accountId: string;
}): Promise<GetGroupListResposne> => {
  try {
    const res: AxiosResponse<GetGroupListResposne> = await AxiosInstance.get(
      `${USER_GROUP_PATH}/list/${accountId}?${qs.stringify(payload)}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getGroupPrevilegeGroupList = async ({
  accountId,
  previlege,
  payload,
}: {
  accountId: string;
  previlege: string;
  payload: GetGroupRequest;
}): Promise<GetGroupListResposne> => {
  try {
    const res: AxiosResponse<GetGroupListResposne> = await AxiosInstance.get(
      `${USER_GROUP_PATH}/totalListPermUserGroup/${previlege}/${accountId}?${qs.stringify(
        payload
      )}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getGroupListForEdit = async ({
  payload,
  accountId,
}: {
  payload: GetGroupRequest;
  accountId: string;
}): Promise<GetGroupListResposne> => {
  try {
    const res: AxiosResponse<GetGroupListResposne> = await AxiosInstance.get(
      `${USER_GROUP_PATH}/list/editUser/${accountId}?${qs.stringify(payload)}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getUserGroupInfo = async ({
  groupId,
  accountId,
}: {
  groupId: string;
  accountId: string;
}): Promise<GetGroupListResposne> => {
  try {
    const res: AxiosResponse<GetGroupListResposne> = await AxiosInstance.get(
      `${USER_GROUP_PATH}/info/${accountId}/${groupId}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const createGroup = async ({
  payload,
  accountId,
}: {
  payload: CreateGroupRequest;
  accountId: string;
}): Promise<CUDGroupResponse> => {
  try {
    const { data }: AxiosResponse<CUDGroupResponse> = await AxiosInstance.post(
      `${USER_GROUP_PATH}/create/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
export const updateGroup = async ({
  payload,
  accountId,
  groupId,
}: {
  payload: CreateGroupRequest;
  accountId: string;
  groupId: string;
}): Promise<CUDGroupResponse> => {
  try {
    const { data }: AxiosResponse<CUDGroupResponse> = await AxiosInstance.put(
      `${USER_GROUP_PATH}/update/${accountId}/${groupId}`,
      payload
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const deleteGroup = async ({
  accountId,
  groupId,
}: {
  accountId: string;
  groupId: string;
}): Promise<CUDGroupResponse> => {
  try {
    const { data }: AxiosResponse<CUDGroupResponse> =
      await AxiosInstance.delete(
        `${USER_GROUP_PATH}/delete/${accountId}/${groupId}`
      );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
